module.exports = __webpack_public_path__ + "img/delsym_12_hour_cough_relief_liquid.0a12a5a8.png";